export const configuration = {
	backendBaseUrl: String(process.env.VUE_APP_BACKEND_BASE_URL),
	apiTimeout: Number(process.env.VUE_APP_API_TIMEOUT),
	authBackendBaseUrl: String(process.env.VUE_APP_AUTH_BACKEND_URL),
	authAuthority: String(process.env.VUE_APP_AUTH_AUTHORITY),
	authClientId: String(process.env.VUE_APP_AUTH_CLIENT_ID),
	authRedirectUri: String(process.env.VUE_APP_AUTH_REDIRECT_URI),
	authSilentRedirectUri: String(process.env.VUE_APP_AUTH_SILENT_REDIRECT_URI),
	authScopes: String(process.env.VUE_APP_AUTH_SCOPES),
	authPostLogoutRedirectUri: String(process.env.VUE_APP_AUTH_POST_LOGOUT_REDIRECT_URI),
	applicationName: String(process.env.VUE_APP_APPLICATION_NAME),
	defaultLocale: String(process.env.VUE_APP_DEFAULT_LOCALE),
	defaultLayout: 'default',
	cubejsApiURL: String(process.env.VUE_APP_CUBEJS_API_URL),
	tarnslatoryBackendURL: String(process.env.VUE_APP_TRANSLATORY_BACKEND_URL),
};
